export const USER_REDUCER_ACTIONS = {
  INITIALIZE: 1,
  RETURN_DEFAULT: 2,
  RETURN_PERSISTED: 3,
  CLEAN: 4
};